'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'microphone';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f130';
var svgPathData = 'M336 192C327.2 192 320 199.2 320 208V256c0 73.5-62.25 132.6-136.8 127.8C115.3 379.1 64 319.6 64 251.5V208C64 199.2 56.8 192 48 192S32 199.2 32 208v42.38c0 83.38 61.63 156.1 144 164.4V480h-64C103.2 480 96 487.2 96 496C96 504.8 103.2 512 112 512h160c8.801 0 16-7.201 16-16c0-8.801-7.199-16-16-16h-64v-65C288.8 406.9 352 338.8 352 256V208C352 199.2 344.8 192 336 192zM192 352c53 0 96-43 96-96v-160c0-52.1-43-96-96-96s-96 43-96 96v160C96 309 139 352 192 352zM128 96c0-35.25 28.75-64 64-64s64 28.75 64 64v160c0 35.25-28.75 64-64 64S128 291.3 128 256V96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMicrophone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faMicrophone.js
// module id = I7wS
// module chunks = 0